import { render } from "./IzinKaryawan.vue?vue&type=template&id=48bd3d94&scoped=true"
import script from "./IzinKaryawan.vue?vue&type=script&lang=js"
export * from "./IzinKaryawan.vue?vue&type=script&lang=js"

import "./IzinKaryawan.vue?vue&type=style&index=0&id=48bd3d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bd3d94"]])

export default __exports__